export default {
  collection: [],
  collection_secondary: [],
  component: 'o-layout-x2-row',
}
